import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { SafePipe } from '@innogy/utils-deprecated';

import { VideoModel } from './video.model';

@Component({
  selector: 'wl-video',
  templateUrl: './video.component.html',
  styleUrls: [],
  standalone: true,
  imports: [NgClass, SafePipe],
})
export class VideoComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() video?: VideoModel;
}
